import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  summary: {
    description: 'orderDrawer.summary',
    defaultMessage: 'Summary',
    id: 'Gl0TDM',
  },
  closedHeader: {
    description: 'Order summary header order date',
    defaultMessage: 'Order Date: {orderDate} - Total: {orderTotal}',
    id: 'GNdOa6',
  },
  shipmentContainsItemsForOrders: {
    defaultMessage: 'This shipment contains items for orders {orderNumberList}.',
    description: 'Message indicating that the shipment contains items for multiple listed orders',
    id: 'ykU21+',
  },
  shipmentPartiallyFulfillsOrder: {
    defaultMessage: 'This shipment partially fulfills order {orderNumber}.',
    description: 'Message indicating that a shipment only contains some, but not all of the items for an order',
    id: 'Fm1cQS',
  },
});
